/*
Loads general user info into state, then supplements it with SMS opt-in info from an AJAX call
Should be converted to a custom hook when the associated controllers are
 */
// Defined in general.js
/* global isLoggedInOrRemembered userObj */

import { onSignInOutExecute } from '../onSignInOutExecute.js';


export const UserSmsInfoMixin = {
    handleSignin: function () {
        if (isLoggedInOrRemembered()) {
            this.setState({
                user: userObj,
            });
            this.loadSmsSettings();
        } else {
            this.setState({
                user: undefined,
            });
        }
    },

    loadSmsSettings: function () {
        $.ajax({
            type: 'get',
            url: '/common/sms-settings.json',
            dataType: 'json',
            success: this.handleSmsSettings,
            error: () => {
                console.error('Error loading SMS settings');
            },
        });
    },

    handleSmsSettings: function (data) {
        const currentUser = this.state.user;
        if (currentUser) {
            this.setState({
                user: Object.assign({}, currentUser, data),
            });
        }
    },

    componentDidMount: function () {
        this.handleSignin();
        onSignInOutExecute(this.handleSignin);
    },
};
